goog.require('el8.template.multiuser_access.enterName');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.enterName = (function() {
    var that = {};
    var theForm = null;
    var hasAnyTargetPhysician;

    function goToChart(faxCode) {
        // signup and go to chart

        var person = extractModelFromForm();

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('submitName', [faxCode]),
            data: JSON.stringify(person),
            async: true,
            success: function(data) {
                location.href=el8.service.urls.get('pageViewDocuments', [faxCode, data.unauth_user_id, data.auth_token]);
            }
        });
    }

    function inputChanged() {
        // called when any input value changed
        var person = extractModelFromForm();
        renderFormFromModel(person);
    }

    var debouncedInputChanged = _.debounce(inputChanged, 250);

    function setupKeyPressedListeners() {
        $(document).on(
            'keypress',
            ':input[name="firstName"], :input[name="lastName"]',
            debouncedInputChanged
        );
    }

    function extractModelFromForm() {
        // extract all the input from the form to create the model
        var person = {
            role : theForm.getVal('role'),
            firstName : theForm.getVal('firstName'),
            lastName : theForm.getVal('lastName'),
            physicianId : theForm.getVal('physicianId'),
            designation : theForm.getVal('designation')
        };
        return person;
    }

    function isPersonComplete(person) {

        // check if we have a complete person model
        if (person.role === 'staff') {
            return person.firstName && person.lastName;
        } else {
            if (!person.physicianId) {
                return person.firstName && person.lastName;
            }
        }
        return true;
    }

    function fieldState(ele, fieldValue) {
        if (fieldValue) {
            fieldOk(ele);
        } else {
            fieldPending(ele);
        }
    }

    function fieldOk(ele) {
        if (!ele) {
            return;
        }
        ele.removeClass("el8FormError").addClass("el8FormSuccess");
    }

    function fieldPending(ele) {
        if (!ele) {
            return;
        }
        ele.removeClass("el8FormError").removeClass("el8FormSuccess");
    }

    function fieldError(ele) {
        if (!ele) {
            return;
        }
        ele.removeClass("el8FormSuccess").addClass("el8FormError");
    }

    function renderFormFromModel(person) {
        // take the person model and make sure the form reflects the model correctly
        // if role is staff, hide the selection of physicians
        if (person.role === 'staff') {
            $('#signup-physician-chooser-container').hide();
            $('#signup-designation-container').hide();
            $('#signup-name-container').show();
        } else {
            $('#signup-physician-chooser-container').show();
            $('#signup-designation-container').show();

            // if "other" is selected, show the firstname/lastname fields
            if (!person.physicianId) {
                $('#signup-name-container').show();
                $('#signup-designation-container').show();
            } else {
                $('#signup-name-container').hide();
                $('#signup-designation-container').hide();
            }
        }

        fieldState($(':input[name="firstName"]').parent(), person.firstName);
        fieldState($(':input[name="lastName"]').parent(), person.lastName);
        fieldState($(':input[name="answer"]').parent(), person.answer);

        if (isPersonComplete(person)) {
            $('#go-to-chart').prop('disabled', false);
        } else {
            $('#go-to-chart').prop('disabled', true);
        }

        if (!hasAnyTargetPhysician) {
            // if there isnt any pre-filled physician, dont ever show the chooser
            $('#signup-physician-chooser-container').hide();
        }
    }

    function setupForm() {
        var fields = [];
        fields = fields.concat([
            {
                name: 'role',
                selector: ':input[name="role"]',
                changeFn: function() {
                    $('.detail-container').show();
                    inputChanged();
                }
            },
            {
                name: 'firstName',
                selector: ':input[name="firstName"]',
                maxLength: 100,
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'lastName',
                selector: ':input[name="lastName"]',
                maxLength: 100,
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'physicianId',
                selector: ':input[name="physicianId"]',
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'designation',
                selector: ':input[name="designation"]',
                changeFn: function() {
                    inputChanged();
                }
            }
        ]);

        var form = new el8.uiwidget.Form({
            fields: fields,
            container: $('#main-form')
        });
        form.render();
        return form;
    }

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */
        if (spec.urls) { el8.service.urls.init(spec.urls); }

        $('.main-content').html(
            el8.template.multiuser_access.enterName.content({})
        );
        hasAnyTargetPhysician = spec.intendedPhysician !== null || spec.otherCanonicalPhysicians.length > 0;
        var faxCode = spec.faxCode;
        if (hasAnyTargetPhysician) {
            $('#signup-physician-selection-container').html(
                el8.template.multiuser_access.signup.physicianNamesSelection({
                    intendedPhysician: spec.intendedPhysician,
                    otherCanonicalPhysicians: spec.otherCanonicalPhysicians
                })
            );
        }
        theForm = setupForm();
        $('.detail-container').hide();
        if (hasAnyTargetPhysician) {
            if (spec.intendedPhysician) {
                theForm.setVal('physicianId', spec.intendedPhysician.id);
            } else {
                theForm.setVal('physicianId', '');
            }
        }
        setupKeyPressedListeners();

        $(document).on('click', '.eula-link', function(e) {
            window.open('https://www.elationemr.com/eula/','_blank');
            e.preventDefault();
            return false;
        });

        $(document).on('click', '#go-to-chart', function(e) {
            goToChart(faxCode);
        });
    };

    return that;

})();
